import { patchData2024 } from "./2024_notes";
import { patchData2025 } from "./2025_notes";
import { patchData2026 } from "./2026_notes";

const patchData = [
  ...patchData2026,
  ...patchData2025,
  ...patchData2024
];

export default patchData;
